import { FC } from 'react';
import { styled } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import logger from '../services/loggerManager';
import { useStartOver } from '../services/flowManager';
import { useNavigate } from 'react-router-dom';
import { MuiTrackerButton } from './TrackerButtonWrapper';
import { ButtonName } from '../constants';

const StyledButton = styled(MuiTrackerButton)(({ theme }) => ({
  border: 'none',
  backgroundColor: theme.palette.common.white,
  textTransform: 'none',
  marginRight: 28,
}));

type StartOverButtonProps = {};
const StartOverButton: FC<StartOverButtonProps> = () => {
  const startOver = useStartOver();
  const navigate = useNavigate();

  return (
    <StyledButton
      buttonName={ButtonName.StartOver}
      startIcon={<ReplayIcon />}
      onClick={() => {
        logger.log('Start over button click', {
          filename: 'StartOverButton.tsx',
          function: 'StartOverButton',
        });

        startOver();
        navigate('/main');
      }}
      variant="outlined"
      color="primary"
      size="large"
    >
      Start Over
    </StyledButton>
  );
};

export default StartOverButton;
